export default __webpack_public_path__ + "static/media/icon_clear_x.949ef66c.svg";